export default "__VITE_ASSET__CJJ9MCDS__"